import axios from 'axios';
import StorageService from './StorageService';
import { getAccessToken } from 'src/redux/actions/authCreator';
import { IPageResult } from 'src/entity/BaseResult';
import { isBoolean } from 'lodash';

/**
 * 封装的http服务
 * @class HttpService
 */
class HttpService {
  get(url: string, params: any = null, config: any = null): Promise<any> {
    if (!!params) {
      url += (url.indexOf('?') < 0 ? '?' : '&') + this.getParamURL(params);
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, this.getRequestConfig(config))
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  async getAll(url: string, params: any = null, config: any = null): Promise<IPageResult<any[]>> {
    let result: IPageResult<any[]> = {
      next: '',
      count: 0,
      previous: '',
      results: []
    }
    try {
      let nextRes: IPageResult<any[]> = await this.get(url, params, config);
      result = {
        next: '',
        previous: '',
        count: nextRes.count,
        results: result.results.concat(nextRes.results)
      };
      if (!!nextRes.next) {
        do {
          nextRes = await this.get(nextRes.next);
          if (!!nextRes) {
            result = {
              next: '',
              previous: '',
              count: result.count,
              results: result.results.concat(nextRes.results)
            };
          }
        } while (!!nextRes.next);
      }
    } catch (e) {
      console.error(e);
    }
    return result;
  }

  post(url: string, data?: any, config: any = null): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, this.getRequestConfig(config))
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  put(url: string, data?: any, config: any = null): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .put(url, data, this.getRequestConfig(config))
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  patch(url: string, data?: any, config: any = null): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .patch(url, data, this.getRequestConfig(config))
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  delete(url: string, config: any = null): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, this.getRequestConfig(config))
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  // upload(url:string, formData: any, config: any = null) {

  // }

  getParamURL(params: any): string {
    let url = '';
    for (const k in params) {
      if (params.hasOwnProperty(k)) {
        if (params[k] !== undefined && params[k] !== null) {
          url += `&${k}=${encodeURIComponent(params[k])}`;
        }
      }
    }

    return url ? url.substring(1) : '';
  }

  getRequestConfig(config: any): any {
    let header = {
      'Accept-Language': StorageService.getItem('language') || 'zh-hans',
    };

    const accessToken = getAccessToken();
    if (!!accessToken) {
      header = Object.assign({}, header, {
        Authorization: `Bearer ${accessToken}`,
      });
    }

    if (!config) {
      config = {
        headers: header,
      };
    } else {
      config = Object.assign({}, config, {
        headers: header,
      });
    }

    return config;
  }

  async setTimeout(ms: number): Promise<any> {
    return new Promise(resolve => {
      const timerId = setTimeout(() => {
        clearTimeout(timerId);
        resolve(timerId);
      }, ms);
    });
  }

  // async clearTimeout(id: NodeJS.Timer) {
  //     if (!!id) {
  //         clearTimeout(id);
  //     }
  // }
}

export default new HttpService();



// WEBPACK FOOTER //
// ./src/services/HttpService.ts